"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformContactToPassenger = void 0;
const Passenger_1 = require("../models/Passenger");
function transformContactToPassenger(contact) {
    const passenger = new Passenger_1.Passenger();
    passenger.birthdayAt = contact.birthdayAt;
    passenger.countryId = contact.countryId;
    passenger.email = contact.email;
    passenger.firstName = contact.firstName;
    passenger.lastName = contact.lastName;
    return passenger;
}
exports.transformContactToPassenger = transformContactToPassenger;
//# sourceMappingURL=transformContactToPassenger.js.map